import React from 'react'
import BoxFormAdd from '../form/boxAdd/BoxFormAdd'
import BoxSeriesFormAdd from '../form/seriesesAdd/BoxSeriesFormAdd'
import AddSeriesInFactoryLineFormAdd from '../form/addSeriesInFactoryLine/AddSeriesInFactoryLineFormAdd'

const PackBoxesOptions = ({ packId }) => {
  return (
    <div className='myBlockHeader__options'>
        <BoxFormAdd
            packId={packId}
        />
        <BoxSeriesFormAdd
            packId={packId}
        />
        <AddSeriesInFactoryLineFormAdd
            packId={packId}
        />
    </div>
  )
}

export default PackBoxesOptions